"use strict";

var _classCallCheck = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Retina = void 0;

var Utils_1 = require("../Utils");

var Retina = /*#__PURE__*/function () {
  function Retina(container) {
    _classCallCheck(this, Retina);

    this.container = container;
  }

  _createClass(Retina, [{
    key: "init",
    value: function init() {
      var container = this.container;
      var options = container.options;

      if (options.detectRetina) {
        this.pixelRatio = Utils_1.Utils.isSsr() ? 1 : window.devicePixelRatio;
      } else {
        this.pixelRatio = 1;
      }

      var ratio = this.pixelRatio;

      if (container.canvas.element) {
        var element = container.canvas.element;
        container.canvas.size.width = element.offsetWidth * ratio;
        container.canvas.size.height = element.offsetHeight * ratio;
      }

      var particles = options.particles;
      this.linksDistance = particles.links.distance * ratio;
      this.linksWidth = particles.links.width * ratio;
      this.moveSpeed = particles.move.speed * ratio;
      this.sizeValue = particles.size.value * ratio;
      this.sizeAnimationSpeed = particles.size.animation.speed * ratio;
      var modes = options.interactivity.modes;
      this.connectModeDistance = modes.connect.distance * ratio;
      this.connectModeRadius = modes.connect.radius * ratio;
      this.grabModeDistance = modes.grab.distance * ratio;
      this.repulseModeDistance = modes.repulse.distance * ratio;
      this.slowModeRadius = modes.slow.radius * ratio;
      this.bubbleModeDistance = modes.bubble.distance * ratio;

      if (modes.bubble.size) {
        this.bubbleModeSize = modes.bubble.size * ratio;
      }
    }
  }, {
    key: "initParticle",
    value: function initParticle(particle) {
      var particlesOptions = particle.particlesOptions;
      var ratio = this.pixelRatio;
      particle.linksDistance = particlesOptions.links.distance * ratio;
      particle.linksWidth = particlesOptions.links.width * ratio;
      particle.moveSpeed = particlesOptions.move.speed * ratio;
      particle.sizeValue = particlesOptions.size.value * ratio;

      if (typeof particlesOptions.size.random !== "boolean") {
        particle.randomMinimumSize = particlesOptions.size.random.minimumValue * ratio;
      }

      particle.sizeAnimationSpeed = particlesOptions.size.animation.speed * ratio;
    }
  }]);

  return Retina;
}();

exports.Retina = Retina;